import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['from', 'to']

  submitRange() {
    if (this.fromTarget.value && this.toTarget.value) this.element.requestSubmit()
  }

  preset({ params: { from, to } }) {
    this.fromTarget.value = from
    this.toTarget.value = to
    this.element.requestSubmit()
  }
}
